import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import "./SidebarCollections.scss";
import DropDownFolder from "../../uiComponents/DropDownFolder";
import OptionMenuCollection from "../../OptionMenuCollection";
import QuickStatsCollections from "../../QuickStatsCollections";
import { getCollectionInfo, getCollectionsForFolder, unColorCollection } from "../../../utils/builder/IScheduleLogic";
import { useDispatch, useSelector } from "react-redux";
import {
  addActiveFolder,
  collectionsSave,
  selectCollectionOnView,
  unselectCollectionOnView,
  setUpModeCompare,
  сhangeCollectionCheckbox
} from "../../../store/actions/collections";
import { CSSTransition } from "react-transition-group";
import UniversalLoader from "../../uiComponents/UniversalLoader";
import { ReactComponent as InfoImg } from "../../../static/icons/info-gray.svg";
import { ReactComponent as OptionImg } from "../../../static/icons/options.svg";
import { useDashboardState } from "../../DashboardContext";
import { ElementsAction, getTableCollection } from "../../../store/actions/table";
import UniversalCheckbox from "../../uiComponents/UniversalCheckbox";
import { onSelectionChange, setQuickInfoCompare } from "../../../store/actions/filter";
import { resetColorSideBarAC } from 'store/actions/colorSidebar';
import { transformCustomColumnsDtoToData } from 'utils/helpers';
import { loadTabSettingsAC } from 'store/actions/tabsSettings';
import { getBounding } from "utils/elementExt";

const SidebarCollections = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { setIsTableHidden } = useDashboardState();

  const { collectionsFolders, collections, compare, quickInfoCompare } = useSelector((state) => state.viewer);
  const { tabs } = useSelector((state) => state.table);

  const [isOpenQuickStats, setOpenQuickStats] = useState(false);
  const [quickInfo, setQuickInfo] = useState(false);
  const [quickStatsButtonPosition, setQuickStatsButtonPosition] = useState(null);
  const [isOpenMenuCollection, setOpenMenuCollection] = useState(false);
  const [menuCollectionButtonPosition, setMenuCollectionButtonPosition] = useState(null);
  const [infoAboutCollection, setInfoAboutCollection] = useState(null);
  const [activeFolder, setActiveFolder] = useState(null);
  const [activeCollection, setActiveCollection] = useState(null);

  useEffect(() => {
    getCollections('My selection sets');
  }, []);

  useEffect(() => {
    if (!tabs.length) {
      setActiveCollection(null);
    }
    tabs.forEach((tab) => {
      if (tab?.active) {
        setActiveCollection(tab.collection);
      }
    })
  });

  useEffect(() => {
    return () => {
      turnOffModeCompare();
    }
  }, []);

  const getCollections = (folderName) => {
    getCollectionsForFolder(folderName).then((collections) => {
      let newCollections = collections;

      if (compare.isModeCompare) {
        newCollections = collections.map((collection) => {

          let checked = false;

          !!compare.collections[folderName] && compare.collections[folderName].forEach((collectionCompare) => {
            if (collection.creationTime === collectionCompare.creationTime) {
              checked = collectionCompare.checked;
            }
          })

          return { ...collection, checked }
        })
      }

      dispatch(collectionsSave(newCollections));
      setActiveFolder(folderName);
      dispatch(addActiveFolder(folderName));
    });
  }

  const openQuickStats = (event, collection) => {
    event.stopPropagation();
    closeOptionMenu();

    const quickStatsButtonClientRect = getBounding(event.target);
    setQuickStatsButtonPosition(quickStatsButtonClientRect);

    getCollectionInfo(collection)
      .then((info) => {
        setQuickInfo(info);
        if (collection.title === isOpenQuickStats) {
          closeQuickStats();
        } else {
          setOpenQuickStats(collection.title);
        }
      });
  }

  const closeQuickStats = () => {
    setOpenQuickStats(false);
  }

  const openMenuCollection = (event, collection) => {
    event.stopPropagation();
    closeQuickStats();

    const MenuCollectionButtonClientRect = getBounding(event.target);
    setMenuCollectionButtonPosition(MenuCollectionButtonClientRect);

    if (collection.title === isOpenMenuCollection) {
      closeOptionMenu()
    } else {
      setOpenMenuCollection(collection.title);
    }

    setInfoAboutCollection({ title: collection.title, description: collection.descreption, folder: activeFolder, color: collection.color, collection: collection })
  }

  const closeOptionMenu = () => {
    setOpenMenuCollection(false);
  }

  const isScroll = () => {
    closeQuickStats();
    closeOptionMenu();
  }

  const handleCollection = (collection) => {
    const collectionScheme = transformCustomColumnsDtoToData(collection.customColumns)
    const currentCollectionId = collection.creationTime

    dispatch(loadTabSettingsAC({
      currentTableId: currentCollectionId,
      columnSchemes: collectionScheme,
      colorScheme: null,
    }))
    dispatch(resetColorSideBarAC())
    setActiveCollection(collection);
    unselectCollectionOnView();
    selectCollectionOnView([collection]);
    viewCollection(collection);
  }

  const viewCollection = (collection) => {
    dispatch(getTableCollection({ collection, folder: activeFolder }));
    setIsTableHidden(false);
  }

  const turnOnModeCompare = () => {
    unselectCollectionOnView();
    dispatch(setUpModeCompare(true));
    dispatch(ElementsAction(null));
    setIsTableHidden(true);
  }

  const turnOffModeCompare = () => {
    unselectCollectionOnView();
    dispatch(setUpModeCompare(false));
    dispatch(setQuickInfoCompare(null));
    if (activeCollection) {
      selectCollectionOnView([activeCollection]);
      setIsTableHidden(false);
    }
  }

  const handleChangeCheckbox = (collection) => {

    const isChecked = !!collection?.checked;

    dispatch(сhangeCollectionCheckbox({ collection, collections, activeFolder, isChecked, quickInfoCompare }));
  }

  return (
    <>
      <div className="sidebar-collections">
        <div className="sidebar-collections__header">
          {t('selection_sets')}
          {
            compare.isModeCompare ?
              <span className="sidebar-collections__compare" onClick={turnOffModeCompare}>{t('close_compare')}</span> :
              <span className="sidebar-collections__compare" onClick={turnOnModeCompare}>{t('compare')}</span>
          }
        </div>
        <DropDownFolder listTitle={activeFolder} list={collectionsFolders} getSelectFolder={getCollections} editFolder={true} />
        {
          collections &&
          <div className="sidebar-collections__list" onScroll={isScroll}>
            {
              collections.map((collection, index) => {
                return (
                  <div className={`sidebar-collections__list-item 
                        ${(activeCollection?.title === collection?.title && !compare.isModeCompare) && 'sidebar-collections__list-item-active'}
                        ${compare.isModeCompare && 'sidebar-collections__list-item-disable'}`}
                    key={collection.title + index} onClick={() => compare.isModeCompare ? handleChangeCheckbox(collection) : handleCollection(collection)}>
                    <div className="sidebar-collections__list-item_left">
                      {
                        compare.isModeCompare &&
                        <div className="sidebar-collections__checkbox">
                          <UniversalCheckbox
                            name={collection.title}
                            checked={collection?.checked}
                          />
                        </div>
                      }
                      <div className="sidebar-collections__list-item__color" style={{ backgroundColor: collection.color }}></div>
                      <div className="sidebar-collections__list-item__name">{collection.title}</div>
                    </div>
                    <div className="sidebar-collections__list-item_right">
                      <InfoImg className={`quick-stats-collections__button ${isOpenQuickStats === collection.title && "quick-stats-collections__button-active"}`}
                        onClick={(event) => openQuickStats(event, collection)} />
                      {
                        !compare.isModeCompare &&
                        <OptionImg className={`option-menu-collection__button ${isOpenMenuCollection === collection.title && "option-menu-collection__button-active"}`}
                          onClick={(event) => openMenuCollection(event, collection)} />
                      }
                    </div>
                  </div>
                )
              })
            }
          </div>
        }
        <CSSTransition
          in={!collections}
          timeout={150}
          unmountOnExit
          classNames="animation"
        >
          <div className="dashboard-proj__preloader">
            <UniversalLoader
              label={t('loading') + "..."}
              labelColor="gray5"
              preloaderColor="black"
              preloaderBgColor="gray5"
              position="center"
              isWithoutContainerBg
            />
          </div>
        </CSSTransition>
        <QuickStatsCollections quickInfo={quickInfo}
          isOpenQuickStats={isOpenQuickStats}
          closeQuickStats={closeQuickStats}
          quickStatsButtonPosition={quickStatsButtonPosition} />
        <OptionMenuCollection isOpenMenuCollection={isOpenMenuCollection}
          closeOptionMenu={closeOptionMenu}
          menuCollectionButtonPosition={menuCollectionButtonPosition}
          infoAboutCollection={infoAboutCollection} />
      </div>
    </>
  );
};

export default SidebarCollections;